import { AxiosRequestConfig, AxiosResponse } from 'axios';
import config from 'config';

import { parseDataByTag, ParsedDataByTag } from 'models/dataByTag';
import { parseGeoInfo, ParsedGeoInfo } from 'models/geoInfo';
import { HttpClient, QueryOptions } from './api-types';

const API_KEY = config.api.apiKey;
const API_URL = config.api.apiUrl;
const API_PATH = config.api.apiPath;
const GEO_API_URL = config.api.geoApiUrl;
const GEO_API_KEY = config.geoApiKey;

const VERSION_NUMBER = 'v1';

export const queryApi = (
  httpClient: HttpClient,
  url: string,
  options?: QueryOptions,
): Promise<AxiosResponse> => {
  const request: AxiosRequestConfig = {
    url,
    method: 'get',
    headers: { 'x-api-key': API_KEY },
  };

  if (options) {
    if (options.params) request.params = options.params;
  }

  return httpClient(request);
};

const queryGeoApi = (httpClient: HttpClient, url: string): Promise<AxiosResponse> => {
  const request: AxiosRequestConfig = {
    url,
    method: 'get',
    headers: { 'x-api-key': GEO_API_KEY },
  };

  return httpClient(request);
};

const getApiUrl = (target: string, version: string): string => {
  return `${API_URL}${API_PATH}/content/${target}/${version}`;
};

export const fetchDataByTag = async (
  httpClient: HttpClient,
  tag: string,
): Promise<ParsedDataByTag> => {
  let response: AxiosResponse | null = null;

  try {
    const geoApiResponse = await queryGeoApi(httpClient, GEO_API_URL);
    const { data: result } = geoApiResponse;
    const geoInfo: ParsedGeoInfo = parseGeoInfo(result);
    const stations = (geoInfo?.stations || []).join(',');

    // The news content personalizes on dmaMarket, not stations
    // (CBSENTAPPS-1478) — keep sending it alongside stations.
    response = await queryApi(httpClient, getApiUrl('by-tag', VERSION_NUMBER), {
      params: {
        tag,
        device: config.ksDeviceType,
        stations,
        dmaMarket: geoInfo?.dmaMarket,
      },
    });
  } catch {
    response = await queryApi(httpClient, getApiUrl('by-tag', VERSION_NUMBER), {
      params: {
        tag,
        device: config.ksDeviceType,
      },
    });
  }

  return parseDataByTag(response);
};
